import { z } from "zod";

import { PluginIntegrationSchema_2023_08_20 } from "./2023-08-20";

export const PluginIntegrationSchema_2024_05_05 =
  PluginIntegrationSchema_2023_08_20;
export type PluginIntegrationType_2024_05_05 = z.infer<
  typeof PluginIntegrationSchema_2024_05_05
>;
